import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPipingWorkTypes } from '../../../api/piping-work-types';

export const getPipingWorkTypesAsync = createAsyncThunk(
  'pipingWorkTypes/getPipingWorkTypes',
  getPipingWorkTypes
);

export interface PipingWorkType {
  id: number;
  name: string;
}

interface PipingWorkTypeState {
  data: PipingWorkType[];
}

const initialState: PipingWorkTypeState = {
  data: []
};

export default createSlice({
  name: 'pipingWorkTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPipingWorkTypesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
